import {api} from './api';

export default class ItemApi {
  #path;
  constructor(itemPath) {
    this.#path = itemPath;
  }
  async add(path, body, onSuccess, onError) {
    return api.v2({
      path,
      method: 'POST',
      body,
    })
    .then(() => onSuccess?.())
    .catch((error) => onError?.(error));
  }
  async set(data, onSuccess, onError) {
    return api.v2({
      path: this.#path,
      method: 'PUT',
      body: {
        data,
      },
    })
    .then((response) => onSuccess?.(response.data))
    .catch((error) => onError?.(error));
  }
  async update(data, onSuccess, onError) {
    return api.v2({
      path: this.#path,
      method: 'PATCH',
      body: {
        data,
      },
    })
    .then((response) => onSuccess?.(response.data))
    .catch((error) => onError?.(error));
  }
  async delete(onSuccess, onError) {
    return api.v2({
      path: this.#path,
      method: 'DELETE',
    })
    .then(() => onSuccess?.())
    .catch((error) => onError?.(error));
  }
}
